import Box from '@components/Box'
import Image from '@components/Image'
import { Anchor, LI, Nav, Span, UL, Link } from '@components/RichTextAndTypography'
import { graphql, useStaticQuery } from 'gatsby'
import { getImage } from 'gatsby-plugin-image'
import React from 'react'
import { StyledFooter, StyledImg } from './styles'
import steam from '@components/Footer/assets/steam.svg'
import tiktok from '@components/Footer/assets/tiktok.svg'
import discord from '@components/Footer/assets/discord.svg'

const Footer = () => {
  const images = useStaticQuery(graphql`
    query {
      logo: file(relativePath: {eq: "header/header-logo.png"}) {
        childImageSharp {
          gatsbyImageData(
            width: 240
            placeholder: NONE
          )
        }
      }
      yonder: file(relativePath: {eq: "footer/yonder.png"}) {
        childImageSharp {
          gatsbyImageData(
            width: 62
            placeholder: NONE
          )
        }
      }
      strelka: file(relativePath: {eq: "footer/strelka.png"}) {
        childImageSharp {
          gatsbyImageData(
            width: 100
            placeholder: NONE
          )
        }
      }
      alg: file(relativePath: {eq: "footer/ALG.png"}) {
        childImageSharp {
          gatsbyImageData(
            width: 146
            placeholder: NONE
          )
        }
      }
    }
  `)

  const socials = [
    {
      image: steam,
      name: 'Steam',
      link: 'https://gsght.com/c/jckrpr',
      alt: 'Steam logo'
    },
    {
      image: tiktok,
      name: 'TikTok',
      link: 'https://www.tiktok.com/@hellisothers',
      alt: 'TikTok logo'
    },
    {
      image: discord,
      name: 'Discord',
      link: 'https://discord.gg/VhbGW6qzWX',
      alt: 'Discord logo'
    }
  ]

  const logo = getImage(images?.logo)

  const publishers = [
    {
      image: getImage(images?.yonder),
      name: 'Yonder',
      link: 'https://www.fromyonder.net/',
      alt: 'Yonder logo'
    },
    {
      image: getImage(images?.strelka),
      name: 'Strelka',
      link: 'https://www.strelkagames.com/',
      alt: 'Strelka Games logo'
    },
    {
      image: getImage(images?.alg),
      name: 'ALG',
      link: 'https://www.alistgames.net/',
      alt: 'a.list games logo'
    }
  ]

  return (
    <StyledFooter
      bg='rgba(37, 37, 37, 0.8)'
      pt={["24px", null, "32px"]}
      pb={["38px", null, "48px"]}
    >
      <Nav
        display="flex"
        maxWidth={["310px", null, 'initial']}
        flexDirection={['column', null, 'row']}
        alignItems="center"
        gridRowGap={["32px"]}
        m="0 auto"
        px={[null, null, '32px', '48px', "64px"]}
      >
        <UL
          flex="1"
          display="flex"
          flexDirection={[null, null, 'column', null, 'row']}
          alignItems={["center", null, 'flex-start', null, 'center']}
          justifyContent={['center', null, null, null, 'flex-start']}
          order={["2", null, "1"]}
          gridColumnGap={["20px", null, null, null, "32px"]}
          gridRowGap={[null, null, "28px"]}
        >
          {socials?.map((social, i) => (
            <LI key={`footer-${i}-${social?.name}`}>
              <Anchor
                href={social?.link}
                display="flex"
                alignItems="center"
              >
                <StyledImg
                  src={social?.image}
                  alt={social?.alt}
                  mr={["8px", null, "20px"]}
                  maxHeight={['22px', null, '28px', null, 'initial']}
                />
                <Span
                  fontWeight={700}
                  fontSize={["16px", null, "20px", null, "24px"]}
                >
                  {social?.name}
                </Span>
              </Anchor>
            </LI>
          ))}
        </UL>
        <Box
          flex="1"
          order={["1", null, "2"]}
          textAlign="center"
        >
          <Image
            image={logo}
            alt="Hell is Others logo"
            maxWidth={["160px", null, "initial"]}
          />
        </Box>
        <UL
          flex="1"
          display="flex"
          flexDirection={[null, null, 'column', null, 'row']}
          alignItems={["center", null, 'flex-end', null, 'center']}
          justifyContent={['center', null, null, null, 'flex-end']}
          order="3"
          gridColumnGap={["20px", null, null, null, "64px"]}
          gridRowGap={[null, null, "18px"]}
        >
          {publishers?.map((publisher, i) => (
            <LI key={`footer-${i}-${publisher?.name}`}>
              <Anchor
                href={publisher?.link}
                display="flex"
                alignItems="center"
              >
                <Image
                  image={publisher?.image}
                  alt={publisher?.alt}
                />
              </Anchor>
            </LI>
          ))}
        </UL>
      </Nav>
      <Box
        flex="1"
        display="flex"
        flexDirection='row'
        alignItems='center'
        justifyContent='center'
        width='100%'
      >
        <Link to="/privacy" paddingRight="4px">Privacy Policy |</Link>
        <div>©{new Date().getFullYear()} A.List Games</div>
      </Box>
    </StyledFooter>
  )
}

export default Footer